$(document).on("experience-form:ready", () => {
  $(".state-select").select2();
  $(".tribes-select").select2({ placeholder: "Select Connected Tribes..." });
  $(".users-select").select2({ placeholder: "Select Connected Editors..." });
  $(".category-list-select").select2({ placeholder: "Select Categories..." });
  $(".page-list-select").select2({
    placeholder: "Select Pages to Display Experience...",
  });
  $(".listing-list-select").select2({ placeholder: "Select Listings..." });
});
